import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="theme-copy-page not-found-page container mx-auto px-4 py-16">
      <div className="max-w-md mx-auto text-center">
        <h1 className="text-9xl font-bold text-primary mb-4">404</h1>
        <h2 className="text-3xl font-bold text-gray-800 mb-4">Page Not Found</h2>
        <p className="text-gray-600 mb-8">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/home"
          className="inline-block px-8 py-3 bg-primary text-white rounded-lg hover:bg-primary-dark transition font-medium"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
